// extracted by mini-css-extract-plugin
export default {"root":"PC2_qeng3bcoMyR_csO9","show":"ERiDpcvFctitW2hxSUz6","message":"AtJ9yTwdx5ueixFSQBA8","link":"TorQR2U74yjX0d0OegD8","dismiss":"unAmqv_OSPZxLfPIE4pd"};